package org.hs_soft.runmynesto.domain.usecase.options.export

import org.hs_soft.runmynesto.domain.model.home.options.export.apaleo_payment_method.ApaleoPaymentMethodModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.export.ApaeloPaymentMethodsRepository

class ApaleoPaymentMethodsUseCase(
    private val apaleoPaymentMethodsRepository: ApaeloPaymentMethodsRepository
) {
    suspend operator fun invoke(): ApaleoPaymentMethodModel {
        return apaleoPaymentMethodsRepository.getPaymentMethods()
    }
} 